import gql from 'graphql-tag'

export const WpsListQuery = gql`
  query WpsListQuery($pageSize: Int = 10, $page: Int = 1, $no: String) {
    wps_list(page: $page, size: $pageSize, no: $no) {
      list {
        id
        rev_no
        no
        actual
        release_date
        welding_processes_names
        welding_positions_names
        pqr_wpqr_wpqt_names
        welding_details_names
        joint_types_names
        weld_types_names
        preparations_names
        metal_transfers_names
        shield_gases_names
        backing_gases_names
        used_base_materials {
          id
          thickness_range
          throat_thickness_range
          diameter_range
          base_material_designation_name
          product_type {
            id
            name
          }
        }
        additional_info
        standard {
          id
          name
        }
      }
      metadata {
        total_count
        total_pages
        prev_page
        current_page
        next_page
      }
    }
  }
`

export const WpsStandardizationsAndMaterialsFetch = gql`
  query WpsStandardizationsQuery {
    wps_standardizations {
      id
      name
      slug
    }
    projects_depth1 {
      id
      name
    }
    base_materials {
      id
      name
      designation_name
      standardization
    }
    filler_materials {
      id
      name
    }
    gas_types {
      id
      name
      description
    }
  }
`

export const WpsDictionariesFetch = gql`
  query WpsDictionariesQuery($standard_id: Int!) {
    wps_dictionaries(standard_id: $standard_id) {
      product_types {
        id
        name
        description
      }
      welding_details {
        id
        name
        description
      }
      welding_processes {
        id
        name
        description
      }
      type_of_current_polarities {
        id
        name
        description
      }
      welding_positions {
        id
        name
        description
      }
      joint_types {
        id
        name
        description
      }
      weld_types {
        id
        name
        description
      }
      preparations {
        id
        name
        description
      }
      metal_transfers {
        id
        name
        description
      }
    }
  }
`
const WpsPartsFragment = gql`
  fragment WpsParts on Wps {
    id
    no
    manufacturer
    shield_gas_flow_rate
    backing_gas_flow_rate
    actual
    standard {
      id
      name
      slug
    }
    welding_detail_ids
    joint_type_ids
    weld_type_ids
    preparations {
      id
      name
    }
    metal_transfers {
      id
      name
    }
    shield_gas_ids
    backing_gas_ids
    additional_info
    bevel
    preheat_temp
    pqr_wpqr_wpqt
    backing
    gouging
    welder_certification_standards
    release_date
    rev_no
    interpass_temp
    post_heating
    preheat_maintenenace_temp
    post_weld_heat_operate
    parameters {
      id
      run
      current
      filler_material {
        id
        name
      }
      filler_material_operate
      filler_material_size
      heat_input
      type_of_current_polarity {
        id
        name
      }
      welding_process {
        id
        name
      }
      welding_position_ids
      travel_speed
      voltage
      wire_feed
    }
    used_base_materials {
      id
      drawing_symbol
      product_type {
        id
        name
      }
      base_material {
        id
        name
        standardization
      }
      diameter
      thickness
      throat_thickness
    }
    attachments {
      id
      data_file_name
      url
    }
    joint_design {
      id
      data_file_name
      url
    }
    welding_sequence {
      id
      data_file_name
      url
    }
    project_ids
  }
`

export const WpsFetchQuery = gql`
query WpsFetchQuery($wps_id: ID!) {
  wps(wps_id: $wps_id) {
    ...WpsParts
  }
}
${WpsPartsFragment}
`

export const createOrUpdateWpsMutation = gql`
  mutation createOrUpdateWps($wps: WpsInput!) {
    createOrUpdateWps(wps: $wps) {
      wps {
       ...WpsParts
      }
      errors
      error_messages
    }
  }
  ${WpsPartsFragment}
`

export const destroyWpsMutation = gql`
  mutation destroyWps($id: ID!) {
    destroyWps(id: $id) {
      response
    }
  }
`

export const assignWpsToProjectsMutation = gql`
  mutation assignWpsToProjects($project_id: ID!, $wps_ids: [ID!]!) {
    assignWpsToProjects(project_id: $project_id, wps_ids: $wps_ids) {
      success
    }
  }
`

export const ProjectsDepth1Query = gql`
  query ProjectsDepth1Query {
    projects_depth1 {
      id
      name
    }
  }
`

export const WpsAssignedToProjectQuery = gql`
  query WpsAssignedToProjectQuery($project_id: ID!) {
    wps_assigned_to_project(project_id: $project_id)
  }
`

export const CreateExportWps = gql`
  mutation createJobs($type: String = "WlWelds::Jobs::ExportWps", $args: String) {
  createJobs(type: $type, args: $args) {
      job {
        id
      }
    }
  }
`

export const ParseWpsPdfMutation = gql`
  mutation parseWpsPdf($pdf_base64: String!) {
    parseWpsPdf(pdf_base64: $pdf_base64) {
      wps_data
      errors
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Wps/mutations.js